import React from 'react';

import { useCarousel } from './useCarousel';
import Arrow from '../../../Images/icons/arrow-right.png';

import {
  Wrapper,
  Background,
  Overlay,
  Content,
  FloatingCard,
  Controls,
  Button,
  LogoContent,
} from './Carousel.styles';

const Carousel = ({ slides, initialIndex = 0, textTrailer }) => {
  const { index, next, prev } = useCarousel(slides.length, { initialIndex });
  const slide = slides[index];

  return (
    <Wrapper data-item={slide.id}>
      <Background
        key={index}
        bgColor={slide.bgColor}
        image={slide.background}
        mobImage={slide.mobBg}
      >
        <Overlay />

        <Content>
          <h4>{slide.category}</h4>
          <h2>{slide.title}</h2>
          <p>{slide.description}</p>
          <a href={slide.trailer}>
            <p>{textTrailer}</p>
          </a>
        </Content>

        <LogoContent>
          {slide.logos?.map((logo, i) => (
            <img
              key={i}
              src={logo.src}
              className={logo.className}
              alt={`Logo ${i}`}
            />
          ))}
        </LogoContent>

        <FloatingCard thumbImage={slide.thumbnail} />
      </Background>

      <Controls>
        <Button onClick={prev}>
          <img src={Arrow} alt="Arrow Prev" className="prev-btn" />
        </Button>
        <Button onClick={next}>
          <img src={Arrow} alt="Arrow Next" />
        </Button>
      </Controls>
    </Wrapper>
  );
};

export default Carousel;
